export default "__VITE_ASSET__n1xcla_9__"